export default __webpack_public_path__ + "locales/ru/DeleteDialog.json?hash=4f78daffdfce6e59adf5a52bb1c04170";